import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { StoreEntityKey } from '@iconik-io/shared-lib/src/redux/entities/types';

import type { SearchScope } from '../../router/search_scope';
import type { AnyObject } from '../../types/common';
import type { RouteParamsAppState } from './types';

type RouteParamsChangePayload = {
  route: string;
  params?: AnyObject;
  query?: AnyObject;
  title?: string;
  titleEntityKey?: StoreEntityKey;
  searchScope?: SearchScope;
  referrer?: string;
};

const initialState: RouteParamsAppState = {
  route: '',
  query: {},
  params: {},
  referrer: document.referrer,
  prevRoute: '',
};

/**
 * @deprecated Compatibility mirror of the router state — see
 * {@link RouteParamsAppState} for what to read instead.
 *
 * Only `route_params_sync` should write to it; every reader is being migrated
 * to the router (FE-7111 for params, FE-7112 for route patterns).
 */
export const routeParamsSlice = createSlice({
  name: 'route_params',
  initialState,
  reducers: {
    routeParamsChange: (
      state,
      action: PayloadAction<RouteParamsChangePayload>,
    ) => {
      state.route = action.payload.route;
      state.params = action.payload.params ?? {};
      state.query = action.payload.query ?? {};
      state.title = action.payload.title;
      state.titleEntityKey = action.payload.titleEntityKey;
      state.searchScope = action.payload.searchScope;
      state.referrer = document.location.href;
    },
    setPrevRoute: (state, action: PayloadAction<string>) => {
      state.prevRoute = action.payload;
    },
  },
});

export const { routeParamsChange, setPrevRoute } = routeParamsSlice.actions;

export const routeParamsReducer = routeParamsSlice.reducer;
